import { render } from "./ProductLayout.vue?vue&type=template&id=2c6b7e2c"
import script from "./ProductLayout.vue?vue&type=script&lang=js"
export * from "./ProductLayout.vue?vue&type=script&lang=js"

import "./ProductLayout.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__